module.exports = __webpack_public_path__ + "img/alloys@2x.57a883d.jpg";